<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-visita-item') {
            next({ name: 'agro-visita-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-visita-item') {
            this.$router.push({ name: 'agro-visita-list' });
        }
    },
};
</script>
